export enum GroupAgentsViews {
    MAIN = 'main',
    REMOVE = 'remove'
}
